<template>
    <v-container fluid grid-list-lg>
        <v-layout>
            <v-flex>
                <h1 class="display-3">Gestión de preguntas</h1>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <draggable v-model="preguntas" @end="preguntasOrden()" :clone="clone">
                    <v-slide-x-reverse-transition group>
                        <v-layout :key="index + p.tipo" v-for="(p,index) in preguntas">
                            <v-flex>
                                <component :is="'tipo-' + p.tipo" v-model="p.datos"></component>
                            </v-flex>
                            <v-flex xs2>
                                <v-btn color="red" flat icon @click="remove(index)">
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-slide-x-reverse-transition>
                </draggable>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex class="text-xs-center">
                <v-btn dark fab color="blue" @click="sheet = true">
                    <v-icon>add</v-icon>
                </v-btn>
            </v-flex>
        </v-layout>
        <v-btn dark fab fixed bottom right color="green" @click="store">
            <v-icon>save</v-icon>
        </v-btn>
        <v-bottom-sheet v-model="sheet">
            <v-list dense>
                <v-subheader>Tipo de campos</v-subheader>
                <template v-for="t in tipos">
                    <v-list-tile @click="add(t)">
                        <v-list-tile-avatar>
                            <v-icon>{{ t.icon }}</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                            <v-list-tile-title>{{ t.nombre }}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>
                </template>
            </v-list>
        </v-bottom-sheet>
    </v-container>
</template>

<script>
    import draggable from 'vuedraggable'
    import tipoText from './tipos/text';
    import tipoTextarea from './tipos/textarea';
    import tipoTitulo from './tipos/titulo';
    import tipoSubtitulo from './tipos/subtitulo';
    import tipoCheck from './tipos/check';
    import tipoRadio from './tipos/radio';
    import tipoFecha from './tipos/fecha';
    import mixinPregunta from '../../mixins/formulario/pregunta';

    export default {
        name: "preguntas",
        components: {draggable, tipoText, tipoTextarea, tipoTitulo, tipoCheck, tipoRadio, tipoSubtitulo, tipoFecha},
        mixins: [mixinPregunta],
        data() {
            return {
                tipos: [
                    {nombre: 'Título', tipo: 'titulo', icon: 'title', datos: {}},
                    {nombre: 'Subtítulo', tipo: 'subtitulo', icon: 'title', datos: {}},
                    {nombre: 'Si/No', tipo: 'sn', icon: 'toggle_off', datos: {}},
                    {nombre: 'Texto', tipo: 'text', icon: 'text_fields', datos: {}},
                    {nombre: 'Area de texto', tipo: 'textarea', icon: 'text_fields', datos: {}},
                    {nombre: 'Opcion única', tipo: 'radio', icon: 'radio_button_checked', datos: {}},
                    {nombre: 'Opcion múltiple', tipo: 'check', icon: 'check_circle_outline', datos: {}},
                    {nombre: 'Fecha', tipo: 'fecha', icon: 'fa-calendar-alt', datos: {}},
                    {nombre: 'Números', tipo: 'numero', icon: 'title', datos: {}},
                ],
                preguntas: [],
                sheet: false,
            }
        },
        methods: {
            clone(el) {
                return el;
            },
            add(p) {
                this.preguntas.push(Object.assign({}, p));
                this.sheet = false;
            },
            remove(index) {
                this.preguntas.splice(index, 1)
            },
            store() {
                this.preguntaStore({
                    formulario_id: this.$route.params.id,
                    preguntas: this.preguntas
                }, r => {
                    this.msjShow(r)
                }, err => console.log(err))
            },
            preguntasOrden() {

            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/formulario/preguntas.vue